import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/$orgSlug/admin/categories")({
  // Component moved to $orgSlug.admin.categories.lazy.tsx for code splitting
});
